import React from 'react'
import { Box } from "@mui/material"
import { AppButtonIcon } from "@components"
import useMultipleActions from "Pages/User/CustomMapping/Table/@hooks/useMultiple"
import { LoadingIconSeeker } from "@ui-seeker/core"
import { bulkFieldModal } from "Pages/User/CustomMapping/@signals"


export default function CustomMappingToolbarSelect({ selectedData, setSelectedRows, path }) {
	const { handleRemoveMultipleMappings, isLoadingDelete } = useMultipleActions(selectedData, setSelectedRows, path)

	const openBulkModal = field => {
		bulkFieldModal.value = { field, path, values: [], rows: selectedData }
	}

	return <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end", mr: 2.5 }}>
		<AppButtonIcon icon="flag" tooltip="Edit Countries for Multiple Mappings" onClick={() => openBulkModal('countries')} />
		<AppButtonIcon icon="building" tooltip="Edit Offices for Multiple Mappings" onClick={() => openBulkModal('offices')} />
		<AppButtonIcon icon="globe-pointer" tooltip="Edit Sites for Multiple Mappings" onClick={() => openBulkModal('sites')} />
		<AppButtonIcon icon="handshake" tooltip="Edit Providers for Multiple Mappings" onClick={() => openBulkModal('providers')} />
		{!!isLoadingDelete && <LoadingIconSeeker/>}
		{!isLoadingDelete && <AppButtonIcon
			icon="trash"
			iconWeight="solid"
			sx={{ color: "error.main" }}
			tooltip="Delete multiple mappings"
			onClick={handleRemoveMultipleMappings}
		/>}
	</Box>
}